import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "form-single-fragment",
  style: {
    "position": "relative"
  }
};
import { ElMessage } from 'element-plus';
import UserController from '@/api/system/UserController';

import { ref, reactive } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    dialog: {}
  },
  setup(__props) {
    const props = __props;
    const formModifyIdentity = ref();
    const formData = reactive({
      realName: '',
      idCardNumber: '',
      extraUserName: '',
      extraPassword: ''
    });
    const rules = ref({
      realName: [{
        required: true,
        message: '请输入姓名',
        trigger: 'blur'
      }, {
        min: 2,
        max: 40,
        message: '姓名长度应在2个字符以上',
        trigger: 'blur'
      }, {
        pattern: /^[\u4e00-\u9fa5·\sa-zA-Z]+$/,
        message: '姓名只能包含中文、英文和空格',
        trigger: 'blur'
      }],
      idCardNumber: [{
        required: true,
        message: '请输入身份证号',
        trigger: 'blur'
      }, {
        pattern: /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/,
        message: '请输入有效的18位身份证号',
        trigger: 'blur'
      }]
    });
    // 初始化数据
    const initData = () => {
      UserController.getIdentity({}).then(res => {
        if (res.data) {
          Object.assign(formData, res.data);
        }
      }).catch(e => {
        console.error('获取实名信息失败', e);
      });
    };
    // 组件挂载时初始化数据
    initData();
    const onCancel = () => {
      if (props.dialog) {
        props.dialog.cancel();
      }
    };
    const onSave = () => {
      formModifyIdentity.value.validate(valid => {
        if (!valid) {
          ElMessage.warning('请检查输入信息是否正确');
          return;
        }
        // 额外的格式校验确认
        const idCardRegex = /^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
        const nameRegex = /^[\u4e00-\u9fa5·\sa-zA-Z]+$/;
        if (!idCardRegex.test(formData.idCardNumber)) {
          ElMessage.error('身份证号格式不正确');
          return;
        }
        if (!nameRegex.test(formData.realName) || formData.realName.length < 2 || formData.realName.length > 40) {
          ElMessage.error('姓名格式不正确，应为2个字符以上，40个字符以下，只能包含中文、英文和空格');
          return;
        }
        // 验证通过后才调用接口
        UserController.updateIdentity(formData).then(res => {
          ElMessage.success('实名信息修改成功');
          if (props.dialog) {
            props.dialog.submit(res);
          }
        }).catch(e => {
          console.error('修改实名信息失败', e);
          ElMessage.error('实名信息修改失败，请重试');
        });
      });
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "formModifyIdentity",
        ref: formModifyIdentity,
        model: _unref(formData),
        class: "full-width-input",
        rules: _unref(rules),
        style: {
          "width": "100%"
        },
        "label-width": "120px",
        size: _ctx.defaultFormItemSize,
        "label-position": "right",
        onSubmit: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "姓名",
              prop: "realName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                class: "input-item",
                modelValue: _unref(formData).realName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(formData).realName = $event),
                modelModifiers: {
                  trim: true
                },
                clearable: true,
                placeholder: "请输入姓名"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "身份证号",
              prop: "idCardNumber"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                class: "input-item",
                modelValue: _unref(formData).idCardNumber,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(formData).idCardNumber = $event),
                modelModifiers: {
                  trim: true
                },
                clearable: true,
                placeholder: "请输入身份证号"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "外部系统用户名",
              prop: "extraUserName"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                class: "input-item",
                modelValue: _unref(formData).extraUserName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formData).extraUserName = $event),
                modelModifiers: {
                  trim: true
                },
                clearable: true,
                placeholder: "请输入外部用户名"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "外部系统密码",
              prop: "extraPassword"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                class: "input-item",
                modelValue: _unref(formData).extraPassword,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formData).extraPassword = $event),
                modelModifiers: {
                  trim: true
                },
                clearable: true,
                placeholder: "请输入外部系统密码"
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createVNode(_component_el_row, {
              class: "no-scroll flex-box",
              type: "flex",
              justify: "end"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_button, {
                size: _ctx.defaultFormItemSize,
                plain: true,
                onClick: _cache[4] || (_cache[4] = $event => onCancel(false))
              }, {
                default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode(" 取消 ", -1)]))]),
                _: 1
              }, 8, ["size"]), _createVNode(_component_el_button, {
                type: "primary",
                size: _ctx.defaultFormItemSize,
                onClick: _cache[5] || (_cache[5] = $event => onSave())
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode(" 保存 ", -1)]))]),
                _: 1
              }, 8, ["size"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules", "size"])]);
    };
  }
});